import SpriteSymbol from "../../../../../../../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "user-interface",
  "use": "user-interface-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" id=\"user-interface\"><path fill=\"var(--bolt-theme-icon, currentColor)\" fill-rule=\"evenodd\" d=\"M20 26h6v-8h-6zm-2 2h10V16H18zM6 10h20V6H6zm-2 2h24V4H4zM30 0H2a2 2 0 00-2 2v28a2 2 0 002 2h28a2 2 0 002-2V2a2 2 0 00-2-2zm0 29a1 1 0 01-1 1H3a1 1 0 01-1-1V3a1 1 0 011-1h26a1 1 0 011 1zM6 26h6v-8H6zm-2 2h10V16H4z\" data-name=\"path-1\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol